export default __webpack_public_path__ + "static/media/03.c829f9fe.svg";